export default __webpack_public_path__ + "static/media/Our-Mission.e492dfb0.png";